export const SlackHookFormComponent = {
    template: require('./slack-hook-form.component.html'),
    bindings: {
        hook: '<'
    },
}